<ng-container>
    <div class="overlay-warp amount-range-filter-wrap">
        <input
            type="number"
            class="number-input"
            [formControl]="fromControl"
            placeholder="{{'grid.reports.amountFromPlaceholder' | translate}}"
            (keydown.enter)="apply()"
            (blur)="apply()"
        />
        <input
            type="number"
            class="number-input"
            [formControl]="toControl"
            placeholder="{{'grid.reports.amountToPlaceholder' | translate}}"
            (keydown.enter)="apply()"
            (blur)="apply()"
        />
    </div>
</ng-container>
